import styled from 'styled-components';
import debounce from 'debounce';

const CustomInput = styled.input`
	border : 1px solid rgba(34,36,38,.15);
	width: 100%;
	transition: box-shadow .1s ease,border-color .1s ease;
	background: #fff;
	padding: 5px;
	text-align: left;
	border-radius: 2px;
`;

function DefaultColumnFilter({
	column : { setFilter},
}) {
	return (
		<CustomInput
			onChange={debounce(e => {
				setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
			}, 400)}
		/>
	);
}

export default DefaultColumnFilter;
